import { ChangeDetectorRef, Component, computed, effect, ElementRef, EventEmitter, inject, Input, input, OnChanges, OnDestroy, OnInit, Output, output, Signal, signal, SimpleChanges, ViewChild, WritableSignal } from '@angular/core';
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { FilterState, GeneratorsList } from '../../../../interfaces/generatorsmodel';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { LookUpService } from '../../../../services/lookupservice';
import { FeedstockService } from '../../../../services/feedstockservice';
import { Regions } from '../../../../interfaces/regions';
import { StreamsList } from '../../../../interfaces/streamsmodel';
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';
import { Observable, Subject, takeUntil } from 'rxjs';
import { FilterService } from '../../../../services/retainFilterControlState.service';
export type FilterKey = 'market' | 'generator' | 'stream';
@Component({
  selector: 'app-filter-control',
  imports: [MatFormField, MatSelectModule, MatFormFieldModule, FormsModule, MatInputModule, MatIcon, MatButtonModule],
  templateUrl: './filter-control.component.html',
  styleUrl: './filter-control.component.scss'
})

export class FilterControlComponent implements OnInit, OnDestroy, OnChanges {

  ///@Input({ required: true }) activeTabIndex!: Signal<number>;
  @Input() canAdd: boolean = false; 
  @Input() canAddExisting: boolean = false;
  @Input({ required: true }) tabIndex!: number;
  @Input() externalFilterState: FilterState | null = null;
  private myTabIndex!: number;
  private destroy$ = new Subject<void>();
  private isInitializing = false;
  
  @Input() addButtonText: string = 'Add Item';
  @Input() searchPlaceholder: string = 'Filter grid...';

  @Output() filterChanged = new EventEmitter<FilterState>();
  @Output() addClicked = new EventEmitter<void>();
  @Output() existingStreamsClicked = new EventEmitter<void>();
  @ViewChild('marketSearchInput') marketSearchInput!: ElementRef<HTMLInputElement>;
  @Output() searchChanged = new EventEmitter<string>();
  showUpload: boolean = false;
  private marketSearchTerm: WritableSignal<string> = signal('');
  private genSearchTerm: WritableSignal<string> = signal('');
  private streamSearchTerm: WritableSignal<string> = signal('');
  displayExistingStreams: WritableSignal<boolean> = signal(false);
  visibleFilters = signal<FilterKey[]>([]);
  markets = signal<Regions[]>([]);
  generators = signal<GeneratorsList[]>([]);
  streams = signal<StreamsList[]>([]);  
  currentFilters: FilterState = {
    tabIndex: 0,
    market: -1,
    generator: null,
    stream: null,
    streamid: null,
    searchText: null,
    isWalmart:  false
  };

  constructor(private lookUp: LookUpService, private fsService: FeedstockService, private cdr: ChangeDetectorRef,
    private retainFilterService: FilterService
  ){
  }
  
  ngOnInit(){
    this.isInitializing = true;
    
    this.myTabIndex = this.tabIndex;
    
    this.visibleFilters.set(this.computeVisibleFilters(this.myTabIndex));
    
    this.displayExistingStreams.set(this.myTabIndex === 1);

    // Load saved state if any
    const savedState = this.retainFilterService.getState(this.myTabIndex);
    if (savedState && savedState.tabIndex === this.myTabIndex) {
      this.currentFilters = { ...savedState };
    } else {
      this.currentFilters = {
        tabIndex: this.myTabIndex,
        market: -1,
        generator: null,
        stream: null,
        streamid: null,
        searchText: null,
        isWalmart:  false
      };
    }
    this.filterChanged.emit({ ...this.currentFilters });
    
    this.fetchMarkets();

    // Allow DOM to settle before enabling user interaction handlers
    setTimeout(() => {
      this.isInitializing = false;
      this.cdr.detectChanges();
    }, 150);
  }

  private computeVisibleFilters(index: number): FilterKey[] {
    switch (index) {
      case 0: return ['market'];
      case 1: return ['market', 'generator'];
      case 2:
      case 3:
      case 4: 
      case 10: return ['market', 'generator', 'stream'];
      default: return [];
    }
  }  

  isVisible(key: FilterKey): boolean {
    return this.visibleFilters().includes(key);
  }

  compareIds(o1: any, o2: any): boolean {
    return o1 != null && o2 != null && o1.toString() === o2.toString();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['addButtonText'] || changes['canAdd']) {
      // If the parent changes the button text while we are on this tab,
      // we must trigger change detection to update the view.
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fetchMarkets(): void {
    this.lookUp.getMarketsList("").subscribe({
      next: async (response) => {
        this.markets.set(response);
        if (!response.length) return;

        const savedState = this.retainFilterService.getState(this.myTabIndex);
        if (!this.currentFilters.market || this.currentFilters.market <= 0) {
          this.currentFilters.market = response[0].id;
        }

        this.saveMarketToState(this.currentFilters.market);

        const needsGeneratorOrStream = this.isVisible('generator');
        if (needsGeneratorOrStream) {
          const savedGen = this.currentFilters.generator;
          this.fetchGenerators(
            `${this.currentFilters.market}`,
            savedGen,
            !savedGen
          );
            //this.currentFilters.market = defaultMarketId;
            //this.onFilterChange('market'); 
        } else {
            this.updateGlobalStateAndEmit();
        }
        //this.filteredMarkets.set(response);
      }
    });
  }

  fetchGenerators(
    marketId: string,
    generatorId: number | null = null,
    suppressEmit: boolean = false): void {
    
    if (!this.isInitializing) {
      this.generators.set([]);
      this.streams.set([]);
    }
    
    {
      const isToteTab = this.myTabIndex === 3;

      const obs$: Observable<any[]> = isToteTab
      ? this.fsService.getToteGenerators(marketId)
      : this.fsService.getGeneratorList(marketId);

      obs$.pipe(takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          // Map Tote generators to the common shape
          const mapped: GeneratorsList[] = isToteTab
            ? (response || []).map(item => this.mapToteGenerator(item))
            : response;
  
          this.generators.set(mapped);
  
          //setTimeout so mat-select renders options before we set the value
          setTimeout(() => {
            // Restore saved generator only if it exists in the loaded list
            if (generatorId && mapped.some(g => g.id === generatorId)) {
              this.currentFilters.generator = generatorId;
            }
  
            this.cdr.markForCheck();
            this.cdr.detectChanges();
  
            const needsStream = this.isVisible('stream');
  
            if (this.currentFilters.generator && needsStream) {
              this.fetchStreams(
                marketId,
                this.currentFilters.generator,
                this.currentFilters.streamid
              );
            } else if (!suppressEmit) {
              this.updateGlobalStateAndEmit();
            }
          }, 0);
        }
      });
    }
  }

  fetchStreams(
    marketId: string,
    genId: number,
    savedStreamId: number | null = null
  ): void {
    if (!this.isInitializing) {
      this.streams.set([]);
    }

    if (!marketId || !genId) return;

    const isToteTab = this.myTabIndex === 3;
    const obs$: Observable<any[]> = isToteTab
      ? this.fsService.getToteStreamList(`${genId}`)
      : this.fsService.getPMStreamList(`${genId}`);

    obs$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        const mappedStreams: StreamsList[] = (response || []).map(item => ({
          streamId: item.id,
          streamName: item.name
        } as StreamsList));

        this.streams.set(mappedStreams);

        if (this.isVisible('stream') && mappedStreams.length > 0) {
          setTimeout(() => {
            // Restore saved stream if it still exists
            if (savedStreamId != null && mappedStreams.find(s => s.streamId === savedStreamId)) {
              this.currentFilters.streamid = savedStreamId;
              this.currentFilters.stream = String(savedStreamId);
            } else {
              // Auto-select first stream (tabs 2/3/4 always need a stream selected)
              this.currentFilters.streamid = mappedStreams[0].streamId;
              this.currentFilters.stream = String(mappedStreams[0].streamId);
            }
            this.updateGlobalStateAndEmit();
            this.cdr.detectChanges();
          }, 0);
        } else {
          this.updateGlobalStateAndEmit();
        }
      }
    });
  }

  onFilterChange(key: FilterKey): void {
    if (key === 'market') {
      this.currentFilters.generator = null;
      this.currentFilters.stream = null;
      this.currentFilters.streamid = null;
      const marketId = this.currentFilters.market?.toString() || '-1';
      if (marketId) {
        console.log("Market changed, fetching generators for market:", marketId);
        this.fetchGenerators(`${marketId}`);
      } else {
        this.generators.set([]);
        this.streams.set([]);
        this.updateGlobalStateAndEmit();
      }
    }
    else if (key === 'generator') {
      this.currentFilters.stream = null;
      this.currentFilters.streamid = null;
      const marketId = this.currentFilters.market?.toString() || '-1';
      const generatorId = this.currentFilters.generator;

    if (generatorId) {
      // For tabs that need streams (Price Matrix, etc)
      if (this.isVisible('stream')) {
        this.fetchStreams(marketId, generatorId);
      } else {
        // For Streams tab (index 1), we just need to emit so the grid loads
        this.updateGlobalStateAndEmit();
      }
    } else {
      this.streams.set([]);
      this.updateGlobalStateAndEmit();
    }
    }
    else if (key === 'stream') {
      this.currentFilters.stream = this.currentFilters.streamid != null
        ? String(this.currentFilters.streamid)
        : null;
      this.updateGlobalStateAndEmit();
    }
  }

  private saveMarketToState(marketId: number): void {
    const existing = this.retainFilterService.getState(this.myTabIndex);
    const updated: FilterState = existing
      ? { ...existing, market: marketId }
      : { tabIndex: this.myTabIndex, market: marketId, generator: null, stream: null, streamid: null, searchText: null, isWalmart: false };
    this.retainFilterService.saveState(updated);
  }

  private updateGlobalStateAndEmit() {
    this.currentFilters.tabIndex = this.myTabIndex;
    const stateToSave = this.getCleanedState(this.currentFilters);
    this.retainFilterService.saveState(stateToSave);
    this.filterChanged.emit({ ...stateToSave });  
  }

  private getCleanedState(state: FilterState): FilterState {
    const index = this.myTabIndex;
    const selectedGen = this.generators().find(g => g.id === state.generator);
    const isWalmart = selectedGen
        ? selectedGen.generatorName.trim().toLowerCase().startsWith('walmart')
        : false;
    const clean: FilterState = {
      tabIndex: index,
      market: state.market,
      generator: null,
      stream: null,
      streamid: null,
      searchText: state.searchText,
      isWalmart:  isWalmart
    };
    if (index >= 1) clean.generator = state.generator;
    if (index >= 2) { clean.stream = state.stream; clean.streamid = state.streamid; }

    return clean;
  }

  onMarketDropdownOpened(isOpen: boolean, searchInput: HTMLInputElement): void {
    if (isOpen) {
      setTimeout(() => {
        searchInput.focus();
      }, 0);
    } else {
      //this.marketSearchTerm.set('');
      //searchInput.value = '';
    }
  }

  onGeneratorDropdownOpened(isOpen: boolean, searchInput: HTMLInputElement): void {
    if (isOpen) {
      setTimeout(() => {
        searchInput.focus();
      }, 0);
    } else {
      //this.marketSearchTerm.set('');
    }
  }
  onStreamDropdownOpened(isOpen: boolean, searchInput: HTMLInputElement): void {
    if (isOpen) {
      setTimeout(() => {
        searchInput.focus();
      }, 0);
    } else {
      //this.filteredstreams = [...this.streams];
      //this.marketSearchTerm.set('');
      //searchInput.value = '';
    }
  }

  onSearchInput(event: Event): void {
    console.log("grid search fired");
    const term = (event.target as HTMLInputElement).value;
    this.currentFilters.searchText = term;
    this.retainFilterService.saveState(this.getCleanedState(this.currentFilters));
    this.searchChanged.emit(term);
  }

  filterMarkets(event: Event) {
    const term = (event.target as HTMLInputElement).value;
    this.marketSearchTerm.set(term.toLowerCase());
  }
  
  filterGenerators(event: Event) {
    const term = (event.target as HTMLInputElement).value;
    this.genSearchTerm.set(term.toLowerCase());
  }
  
  filterStreams(event: Event) {
    const term = (event.target as HTMLInputElement).value;
    this.streamSearchTerm.set(term.toLowerCase());
  }

  filteredMarkets = computed(() => {
    const term = this.marketSearchTerm();
    return this.markets().filter(m => m.regionName.toLowerCase().includes(term));
  });

  filteredGenerators = computed(() => {
    const term = this.genSearchTerm();
    return this.generators().filter(m => m.generatorName.toLowerCase().includes(term));
  });

  filteredStreams = computed(() => {
    const term = this.streamSearchTerm();
    return this.streams().filter(m => m.streamName.toLowerCase().includes(term));
  });

  private mapToteGenerator(item: any): GeneratorsList {
    return {
      id: item.id,
      generatorName: item.customerName,
      contactName: '', contactPhone: '', contactEmail: '',
      siteNumber: null, accountNumber: null,
      addressLine1: null, addressLine2: null,
      city: null, state: null, zipCode: null,
      marketName: null, marketId: null,
      createdDate: null, createdBy: null,
      lastModifiedDate: null, lastModifiedBy: null,
      lgX_ContactName: null, lgX_ContactPhone: null, lgX_ContactEmail: null,
      environment_Fee_Flag: null, isTipFeeRequired: null,
      environment_Fee_FlagDescription: null, isTipFeeRequiredDescription: null,
      isVRSite: null, isVRSiteDescription: null
    };
  }
}
